(function () {
    'use strict';
    angular.module('app')
        .controller('homeController', homeController);

    function homeController(viewModel) {
        var vm=this;

        init();

        function init() {
            vm.data=viewModel.data;
            var menuSerilNo = getMenuQueryString();
            if (parseInt(menuSerilNo) === 31 || menuSerilNo === undefined)
            {
                $(".ui-blackCover").css("display","none");
                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');
            }
        }
    }
})();